// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__IowBc","row":"styles_row__2G6BT"};